import { useToken } from '@cof/fs-style-utils';
import { unsafeCSS } from 'lit';

export function fsDesignToken(token) {
  const value = useToken(token);
  if (!value) throw new Error(`Unknown fs design token: ${token}`);

  // The tokens come back as var(--some-var, constant) which is fine for most css rules
  // but does not work for media queries. Here we parse out the constant value and just
  // return that.
  const varValues = value.split(',');
  varValues.shift();
  const defaultValue =
    varValues.length > 0 ? varValues.join(',').trim().slice(0, -1) : null;
  return unsafeCSS(defaultValue || value);
}
